import React, { useContext, useEffect, useState } from "react";
import { billpunchbasicauth } from "../../utils/Credentials";
import { GlobalContext } from "../../Context/GlobalState";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";

const Inactiveemployee = () => {
  const { password, username } = billpunchbasicauth;
  const [activity, setActivity] = useState([]);
  const { user, setTransactionLoaderState } = useContext(GlobalContext);

  const getActivity = async () => {
    setTransactionLoaderState(true);
    try {
        const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        firmid: user.firm_id,
      });

      var requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetAllInactiveEmployee`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setActivity(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };

  useEffect(() => {
    getActivity();
  }, []);
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const datePart = dateString.split(",")[0]; 
    return datePart || "N/A"; 
  };
  return (
    <div className="mt-4">
      <h5 className="pt-3">Inactive Employees</h5>
      <table className="table ">
        <thead>
          <tr>
            <th  style={{background:"#FEFAE0", color:"#387F39", border:"1px solid #dee2e6"}}>Employee Code</th>
            <th  style={{background:"#FEFAE0", color:"#387F39", border:"1px solid #dee2e6"}}>Name</th>
            {/* <th  style={{background:"#FEFAE0", color:"#387F39", border:"1px solid #dee2e6"}}>Designation</th> */}
            <th  style={{background:"#FEFAE0", color:"#387F39", border:"1px solid #dee2e6"}}>Department</th>
            <th  style={{background:"#FEFAE0", color:"#387F39", border:"1px solid #dee2e6"}}>Mobile</th>
            <th  style={{background:"#FEFAE0", color:"#387F39", border:"1px solid #dee2e6"}}>Email</th>
            <th  style={{background:"#FEFAE0", color:"#387F39", border:"1px solid #dee2e6"}}>Joining Date</th>
            <th  style={{background:"#FEFAE0", color:"#387F39", border:"1px solid #dee2e6"}}>Age</th>
            <th  style={{background:"#FEFAE0", color:"#387F39", border:"1px solid #dee2e6"}}>PAN</th>
          </tr>
        </thead>
        <tbody>
          {activity.length > 0 ? (
            activity.map((emp) => (
              <tr key={emp.empid}>
                <td style={{fontSize:".9rem", fontWeight:"400"}}>{emp.empcode}</td>
                <td style={{fontSize:".9rem", fontWeight:"400"}}>{`${emp.firstname} ${emp.middlename || ""} ${emp.lastname || ""}`}</td>
                {/* <td style={{fontSize:".9rem", fontWeight:"400"}}>{emp.designation}</td> */}
                <td style={{fontSize:".9rem", fontWeight:"400"}}>{emp.department}</td>
                <td style={{fontSize:".9rem", fontWeight:"400"}}>{emp.mobile}</td>
                <td style={{fontSize:".9rem", fontWeight:"400"}}>{emp.email}</td>
                <td style={{fontSize:".9rem", fontWeight:"400"}}>{formatDate(emp.joiningdate)}</td>
                <td style={{fontSize:".9rem", fontWeight:"400"}}>{emp.age}</td>
                <td style={{fontSize:".9rem", fontWeight:"400"}}>{emp.pan}</td>
              </tr>
            ))
          ) : (
            <tr>
            <td colSpan="8" className="text-center">No inactive employees found.</td>
          </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Inactiveemployee;
